import type { SkinManifest } from './types.js';

/**
 * 皮肤注册表:新皮肤 = 新目录 + 这里一行;懒加载,用到才下载。
 * 哪个页面套哪套由 ui/skin-scope.ts 定(学生端 / 家长端 = shell,其余 = default),这里不管选择。
 */
export const SKINS: Record<string, () => Promise<SkinManifest>> = {
  default: () => import('./default/index.js').then((m) => m.defaultSkin),
  // 「深色外壳」:学生端 / 家长端。只进后台、只看对外页面的人不会下载它
  shell: () => import('./shell/index.js').then((m) => m.shellSkin),
  // 「光速启航」结构(样张,学生端可切换;见 ui/skin-scope.ts)
  academy: () => import('./academy/index.js').then((m) => m.academySkin),
};

export type { ArtKey, SkinManifest } from './types.js';
